const supabase = {
  apiUrl: 'https://tqtbjmuayihzxmoopvkw.supabase.co',
  apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRxdGJqbXVheWloenhtb29wdmt3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2Nzg0OTcyODEsImV4cCI6MTk5NDA3MzI4MX0.bCqIMehnQRpJNYNcxYSFRE_ywJwLyc4_1yVnX7DFVGI'
}

export default {supabase};